import * as types from './ClaimsTypes';

export default function ClaimsReducer(state, action) {
    const { type, payload } = action;

    switch (type) {
        case types.GET_CLAIMS:
            return {
                ...state,
                getClaims: {
                    ...state.getClaims,
                    claims: payload.data,
                    firstClaim: payload.first,
                    lastClaim: payload.last,
                    nextClaims: payload.next,
                    claimsFilter: [],
                    loading: false,
                    hasSuccess: true,
                    hasError: {
                        code: null,
                        message: null
                    },
                },
            };
        case types.GET_CLAIMS_LOADING:
            return {
                ...state,
                getClaims: {
                    ...state.getClaims,
                    loading: true
                },
            };
        case types.GET_CLAIMS_ERROR:
            return {
                ...state,
                getClaims: {
                    ...state.getClaims,
                    loading: false,
                    hasSuccess: false,
                    hasError: {
                        code: payload.code,
                        message: payload.message
                    },
                },
            };
        case types.GET_CLAIMS_ALL_MONTH:
            return {
                ...state,
                getClaimsAllMonth: {
                    ...state.getClaimsAllMonth,
                    claims: payload.data,
                    loading: false,
                    hasSuccess: true,
                    hasError: {
                        code: null,
                        message: null
                    }
                },
            };
        case types.GET_CLAIMS_ALL_MONTH_LOADING:
            return {
                ...state,
                getClaimsAllMonth: {
                    ...state.getClaimsAllMonth,
                    loading: true
                },
            };
        case types.GET_CLAIMS_ALL_MONTH_ERROR:
            return {
                ...state,
                getClaimsAllMonth: {
                    ...state.getClaimsAllMonth,
                    loading: false,
                    hasSuccess: false,
                    hasError: {
                        code: payload.code,
                        message: payload.message
                    }
                },
            };
        case types.GET_CLAIMS_FILTER:
            return {
                ...state,
                getClaims: {
                    ...state.getClaims,
                    claimsFilter: payload.data,
                    firstClaim: payload.first,
                    lastClaim: payload.last,
                    nextClaims: payload.next,
                    loading: false
                },
            };
        case types.GET_CLAIMS_FILTER_LOADING:
            return {
                ...state,
                getClaims: {
                    ...state.getClaims,
                    loading: true
                },
            };
        case types.GET_CLAIMS_FILTER_ERROR:
            return {
                ...state,
                getClaims: {
                    ...state.getClaims,
                    claimsFilter: [],
                    loading: false
                },
            };
        case types.GET_CLAIMS_EXCEL:
            return {
                ...state,
                getClaimsExcel: {
                    ...state.getClaimsExcel,
                    claims: payload.data,
                    hasSuccess: true,
                    loading: false
                },
            };
        case types.GET_CLAIMS_EXCEL_LOADING:
            return {
                ...state,
                getClaimsExcel: {
                    ...state.getClaimsExcel,
                    loading: true
                },
            };
        case types.GET_CLAIMS_EXCEL_ERROR:
            return {
                ...state,
                getClaimsExcel: {
                    ...state.getClaimsExcel,
                    loading: false,
                    hasSuccess: false,
                    hasError: {
                        code: payload.code,
                        message: payload.message
                    }
                },
            };
        case types.GET_CLAIMS_FILTER_EXCEL:
            return {
                ...state,
                getClaimsExcel: {
                    ...state.getClaimsExcel,
                    claimsFilter: payload.data,
                    hasSuccess: true,
                    loading: false
                },
            };
        case types.GET_CLAIMS_FILTER_EXCEL_LOADING:
            return {
                ...state,
                getClaimsExcel: {
                    ...state.getClaimsExcel,
                    loading: true
                },
            };
        case types.GET_CLAIMS_FILTER_EXCEL_ERROR:
            return {
                ...state,
                getClaimsExcel: {
                    ...state.getClaimsExcel,
                    loading: false,
                    hasSuccess: false,
                    hasError: {
                        code: payload.code,
                        message: payload.message
                    }
                },
            };
        case types.CLAIMS_EXCEL_RESET_STATE:
            return {
                ...state,
                getClaimsExcel: {
                    ...state.getClaimsExcel,
                    claims: [],
                    claimsFilter: [],
                    loading: false,
                    hasSuccess: false,
                    hasError: {
                        code: null,
                        message: null
                    }
                },
            };
        case types.GET_CLAIMS_BY_ID:
            return {
                ...state,
                getClaimsById: {
                    ...state.getClaimsById,
                    claim: payload,
                    loading: false,
                    hasSuccess: true,
                    hasError: {
                        code: null,
                        message: null
                    },
                },
            };
        case types.GET_CLAIMS_BY_ID_LOADING:
            return {
                ...state,
                getClaimsById: {
                    ...state.getClaimsById,
                    loading: true
                },
            };
        case types.GET_CLAIMS_BY_ID_ERROR:
            return {
                ...state,
                getClaimsById: {
                    ...state.getClaimsById,
                    loading: false,
                    hasSuccess: false,
                    hasError: {
                        code: payload.code,
                        message: payload.message
                    },
                },
            };
        case types.GET_ACTIONS_CLAIMS:
            return {
                ...state,
                getActionsClaims: {
                    ...state.getActionsClaims,
                    actionsClaims: payload,
                    loading: false,
                    hasSuccess: true,
                    hasError: {
                        code: null,
                        message: null
                    },
                },
            };
        case types.GET_ACTIONS_CLAIMS_LOADING:
            return {
                ...state,
                getActionsClaims: {
                    ...state.getActionsClaims,
                    loading: true
                },
            };
        case types.GET_ACTIONS_CLAIMS_ERROR:
            return {
                ...state,
                getActionsClaims: {
                    ...state.getActionsClaims,
                    loading: false,
                    hasSuccess: false,
                    hasError: {
                        code: payload.code,
                        message: payload.message
                    },
                },
            };
        case types.UPDATE_CLAIMS_BY_ID:
            return {
                ...state,
                updateClaimsById: {
                    ...state.updateClaimsById,
                    loading: false,
                    hasSuccess: {
                        type: payload.newType,
                        success: true
                    },
                    hasError: {
                        code: null,
                        message: null
                    }
                },
                getClaimsById: {
                    ...state.getClaimsById,
                    claim: {
                        ...state.getClaimsById.claim,
                        accion: payload.newAction,
                        solucion: payload.newSolution,
                        status: payload.newStatus,
                        usuarioAtendio: payload.newUserAttends
                    },
                },
            };
        case types.UPDATE_CLAIMS_BY_ID_LOADING:
            return {
                ...state,
                updateClaimsById: {
                    ...state.updateClaimsById,
                    loading: true
                },
            };
        case types.UPDATE_CLAIMS_BY_ID_ERROR:
            return {
                ...state,
                updateClaimsById: {
                    ...state.updateClaimsById,
                    loading: false,
                    hasSuccess: {
                        type: null,
                        success: false
                    },
                    hasError: {
                        code: payload.code,
                        message: payload.message
                    }
                },
            };
        case types.CLAIMS_RESET_STATE:
            return {
                ...state,
                getClaims: {
                    claims: [],
                    firstClaim: null,
                    lastClaim: null,
                    nextClaims: null,
                    claimsFilter: [],
                    loading: false,
                    hasSuccess: false,
                    hasError: {
                        code: null,
                        message: null
                    }
                },
                getClaimsAllMonth: {
                    claims: [],
                    loading: false,
                    hasSuccess: false,
                    hasError: {
                        code: null,
                        message: null
                    },
                },
                getClaimsById: {
                    claim: null,
                    loading: false,
                    hasSuccess: false,
                    hasError: {
                        code: null,
                        message: null
                    }
                },
                updateClaimsById: {
                    loading: false,
                    hasSuccess: {
                        type: null,
                        success: false
                    },
                    hasError: {
                        code: null,
                        message: null
                    }
                },
                getActionsClaims: {
                    actionsClaims: [],
                    loading: false,
                    hasSuccess: false,
                    hasError: {
                        code: null,
                        message: null
                    }
                },
                getClaimsExcel: {
                    claims: [],
                    claimsFilter: [],
                    loading: false,
                    hasSuccess: false,
                    hasError: {
                        code: null,
                        message: null
                    }
                }
            };
    
        default:
            return state;
    }
}